import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CDV_ACCESS_URL } from '../../data/academiaCdv';
import { trackPage } from '../../utils/analytics';
interface CdvCtaButtonProps {
  trackingId?: string;
  href?: string;
}
export function CdvCtaButton({
  trackingId = 'cdv_cta_click',
  href = CDV_ACCESS_URL
}: CdvCtaButtonProps) {
  return <a href={href} target="_blank" rel="noopener noreferrer" onClick={() => trackPage(trackingId)} className="group flex w-full items-center justify-center gap-3 rounded-xl bg-gold-metallic px-5 py-3.5 md:py-4 text-center text-black shadow-lg transition-[background-color,transform] duration-150 ease-out hover:bg-[#E5C04B] active:scale-[0.99] focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-28" data-mp="i7sgmgs1lqfx">
      <span className="flex flex-col leading-tight" data-id="element-29" data-mp="1pl2h8e2f57kp">
        <span className="text-[0.95rem] sm:text-base md:text-lg font-extrabold uppercase" data-id="element-30" data-mp="1tnqsstiiosld">
          Sí, quiero generar ingresos reales
        </span>
        <span className="mt-1 text-xs md:text-sm font-semibold uppercase tracking-wide text-black/75" data-id="element-31" data-mp="mh1qnoi1p1rk">
          Acceso inmediato por $47/mes
        </span>
      </span>
      <ArrowRightIcon className="hidden sm:block h-6 w-6 flex-shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-32" data-mp="w8oc0do3kh81" />
    </a>;
}